import Phaser from 'phaser';
import { createGameConfig } from './game/config';

const parent = document.getElementById('game-container');
if (!parent) {
  throw new Error('Missing #game-container element');
}

const game = new Phaser.Game(createGameConfig(parent));
// Expose for automated smoke / screenshot helpers (DEV).
(window as unknown as { __RB_GAME__?: Phaser.Game }).__RB_GAME__ = game;
